var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-snackbar',{attrs:{"timeout":"2000","top":""},model:{value:(_vm.snackbarShow),callback:function ($$v) {_vm.snackbarShow=$$v},expression:"snackbarShow"}},[_vm._v(_vm._s(_vm.snackbarMsg))])
}
var staticRenderFns = []

export { render, staticRenderFns }